{
  "success": {
    "analyses/setMovable": "Analyse mise à jour",
    "analyses/moveIntoPlan": "Analyse déplacée avec succès dans le plan",
    "analyses/remove": "Analyse déplanifiée avec succès",
    "analysisDefinitions/create": "Nouvelle définition d'analyse ajoutée",
    "analysisDefinitions/edit": "Définition d'analyse modifiée",
    "analysisDefinitions/remove": "Définition d'analyse supprimée",
    "analysisDraft/create": "Nouveau brouillon d'analyse ajouté",
    "analysisDraft/edit": "Brouillon d'analyse modifié",
    "samples/delete-unlocked": "Tous les échantillons non planifiés supprimés",
    "assets/remove": "Instrument supprimé avec succès",
    "assets/create": "Nouvel instrument ajouté",
    "assets/edit": "Instrument modifié",
    "competenceGroups/create": "Nouveau groupe de compétences créé avec succès",
    "competenceGroups/edit": "Groupe de compétences modifié avec succès",
    "competenceGroups/remove": "Groupe de compétences supprimé avec succès",
    "iap/run": "IAP exécuté avec succès",
    "iap/runFillInSamples": "Échantillons remplis avec succès",
    "integrationSheets/createActionSheet": "Feuille ajoutée",
    "integrationSheets/createProjectTemplateSheets": "Feuille ajoutée",
    "integrationSheets/createSampleSheet": "Feuille ajoutée",
    "integrationSheets/editActionSheet": "Feuille modifiée",
    "integrationSheets/editProjectTemplateSheet": "Feuille modifiée",
    "integrationSheets/editSampleSheet": "Feuille modifiée",
    "integrationSheets/removeActionSheet": "Feuille supprimée",
    "integrationSheets/removeProjectTemplateSheet": "Feuille supprimée",
    "integrationSheets/removeSampleSheet": "Feuille supprimée",
    "integrationSheets/saveSapConversionSheet": "Feuille d'importation de projet enregistrée",
    "members/create": "Membre ajouté",
    "members/createAsAdmin": "Membre ajouté",
    "members/edit": "Membre modifié",
    "members/archive": "Membre archivé",
    "projectActions/editPlanned": "Action de projet modifiée",
    "projectActions/move": "Action de projet placée sur le planning",
    "projectActions/setMovable": "Action de projet mise à jour",
    "projectActions/setLocation": "Lieu mis à jour",
    "projectActions/setLocationUnplanned": "Lieu mis à jour",
    "projectActions/editUnplanned": "Action de projet non planifiée modifiée",
    "projectActions/removePlanned": "Projet déplanifié",
    "projects/create": "Nouveau projet ajouté",
    "projects/edit": "Projet mis à jour",
    "projects/remove": "Projet supprimé",
    "projects/delete-unplanned": "Tous les projets non planifiés supprimés",
    "projects/lockProject": "Projet verrouillé",
    "projects/unlockProject": "Projet déverrouillé",
    "projectTemplates/create": "Nouveau modèle de projet créé",
    "projectTemplates/createDraft": "Nouveau brouillon de modèle de projet créé",
    "projectTemplates/edit": "Modèle de projet modifié",
    "projectTemplates/editDraft": "Brouillon de modèle de projet modifié",
    "projectTemplates/remove": "Modèle de projet supprimé",
    "whiteTasks/remove": "Tâche supprimée avec succès",
    "whiteTasks/create": "Nouvelle tâche ajoutée",
    "whiteTasks/edit": "Tâche modifiée avec succès",
    "whiteTasks/createRecurrence": "Récurrence créée",
    "whiteTasks/removeRecurrence": "Tâches récurrentes supprimées",
    "teamStatus/start": "Mode simulation activé",
    "teamStatus/accept": "Modifications en mode simulation appliquées",
    "teamStatus/discard": "Modifications en mode simulation abandonnées",
    "customers/addCustomer": "Client ajouté",
    "customers/editCustomer": "Client modifié",
    "customers/deleteCustomer": "Client supprimé",
    "team/create-api-token": "Jeton API créé",
    "team/delete-api-token": "Jeton API supprimé"
  },
  "error": {
    "analyses/remove/ERROR": "Échec de la déplanification de l'analyse",
    "analysisDefinitions/create/ERROR": "Échec de l'ajout de la nouvelle définition d'analyse",
    "analysisDefinitions/remove/ERROR": "Échec de la suppression de la définition d'analyse",
    "assets/remove/ERROR": "Échec de la suppression de l'instrument",
    "assets/create/ERROR": "Échec de l'ajout de l'instrument",
    "auth/login/ERROR": "Échec de la connexion",
    "competenceGroups/create/ERROR": "Échec de la création du groupe de compétences",
    "competenceGroups/remove/ERROR": "Échec de la suppression du groupe de compétences",
    "iap/run/ERROR": "Échec de l'exécution d'IAP",
    "iap/runFillInSamples/ERROR": "Échec du remplissage des échantillons",
    "integrationSheets/createActionSheet/ERROR": "Échec de l'ajout de la feuille",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Échec de l'ajout de la feuille",
    "integrationSheets/createSampleSheet/ERROR": "Échec de l'ajout de la feuille",
    "integrationSheets/editActionSheet/ERROR": "Échec de la modification de la feuille",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Échec de la modification de la feuille",
    "integrationSheets/editSampleSheet/ERROR": "Échec de la modification de la feuille",
    "integrationSheets/removeActionSheet/ERROR": "Une erreur s'est produite lors de la suppression de la feuille",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Une erreur s'est produite lors de la suppression de la feuille",
    "integrationSheets/removeSampleSheet/ERROR": "Une erreur s'est produite lors de la suppression de la feuille",
    "loading/fetchAll/ERROR": "Échec du chargement",
    "members/create/ERROR": "Échec de l'ajout du membre",
    "members/createAsAdmin/ERROR": "Échec de l'ajout du membre",
    "members/archive/ERROR": "Échec de l'archivage du membre",
    "projectActions/move/ERROR": "Échec du déplacement de l'action sur le planning",
    "projectActions/removePlanned/ERROR": "Échec de la déplanification de l'action",
    "projectActions/setLocation/ERROR": "Échec de la mise à jour du lieu",
    "projectActions/setLocationUnplanned/ERROR": "Échec de la mise à jour du lieu",
    "projects/create/ERROR": "Échec de l'ajout du nouveau projet",
    "projects/remove/ERROR": "Échec de la suppression du projet",
    "projects/delete-unplanned/ERROR": "Échec de la suppression des projets non planifiés",
    "projects/lockProject/ERROR": "Échec du verrouillage des actions",
    "projectTemplates/create/ERROR": "Échec de la création du nouveau modèle de projet",
    "projectTemplates/createDraft/ERROR": "Échec de la création du nouveau brouillon de modèle de projet",
    "projectTemplates/remove/ERROR": "Échec de la suppression du modèle de projet",
    "whiteTasks/remove/ERROR": "Échec de la suppression de la tâche",
    "whiteTasks/create/ERROR": "Échec de la création",
    "teamStatus/start/ERROR": "Échec de l'activation du mode simulation",
    "teamStatus/accept/ERROR": "Échec de l'application des modifications en mode simulation",
    "teamStatus/discard/ERROR": "Échec de l'abandon des modifications en mode simulation",
    "customers/deleteCustomer/ERROR": "Impossible de supprimer le client",
    "customers/addCustomer/ERROR": "Impossible d'ajouter le client",
    "customers/editCustomer/ERROR": "Impossible de modifier le client",
    "team/create-api-token/ERROR": "Impossible de créer le jeton API",
    "team/delete-api-token/ERROR": "Impossible de supprimer le jeton API"
  },
  "adhoc": {
    "welcomeBack": "Bienvenue de retour !",
    "noSoundDetected": "Aucun son détecté. Veuillez réessayer.",
    "noMicrophoneDetected": "Aucun microphone détecté. Veuillez réessayer.",
    "iapRunning": "Un instant - l'IAP de votre équipe s'exécute",
    "failedDiscardNotLoggedOut": "Échec de l'abandon des modifications. Vous n'avez pas été déconnecté !",
    "cannotDragRecurrentTask": "Vous ne pouvez pas glisser-déposer une tâche grise récurrente",
    "cannotMoveImportedTasks": "Vous ne pouvez pas déplacer les tâches importées",
    "noCheckboxesSelected": "Aucune case à cocher sélectionnée",
    "analysisUpdatedRefresh": "Analyse mise à jour, veuillez actualiser",
    "analysisUpdatedByAnotherUser": "L'analyse a été mise à jour par un autre utilisateur, veuillez actualiser",
    "copiedToClipboard": "Copié dans le presse-papiers",
    "couldNotCopyToClipboard": "Impossible de copier dans le presse-papiers",
    "chooseFirstAction": "Veuillez choisir le premier {{itemType}}",
    "chooseSecondAction": "Veuillez choisir le deuxième {{itemType}}",
    "chooseTwoDifferent": "Veuillez choisir deux {{itemType}} différents",
    "constraintConflicts": "Cette contrainte entre en conflit avec les contraintes existantes",
    "sampleCreated": "Échantillon créé",
    "sampleDeleted": "Échantillon supprimé",
    "samplesUpdated": "Échantillons mis à jour",
    "sampleMarkedDone": "Échantillon marqué comme fait",
    "memberPermissionsChanged": "Permissions des membres modifiées",
    "chooseUniqueName": "Veuillez choisir un nom unique",
    "fillRequiredFields": "Veuillez remplir les champs obligatoires",
    "couldNotDetermineSampleIdDone": "Impossible de déterminer l'ID d'échantillon à marquer comme fait",
    "couldNotDetermineSampleIdDelete": "Impossible de déterminer l'ID d'échantillon à supprimer",
    "couldNotDetermineSampleIdDeleteMissing": "Impossible de déterminer l'ID d'échantillon à supprimer — données manquantes. Vérifiez la console pour plus de détails.",
    "anErrorOccurred": "Une erreur s'est produite",
    "selectFileBeforeSubmitting": "Veuillez sélectionner au moins un fichier avant de soumettre",
    "helpPageUpdated": "Page d'aide mise à jour",
    "processingStarted": "Traitement commencé",
    "failedLoadingIcalFiles": "Échec du chargement des fichiers iCalendar",
    "unsortBeforePasting": "Veuillez désactiver le tri du tableau avant de coller plusieurs cellules.",
    "fillAllRequiredFields": "Veuillez remplir tous les champs obligatoires",
    "unsavedChangesConfirmLeave": "Vous avez des modifications non enregistrées. Pour confirmer que vous souhaitez partir, appuyez à nouveau sur le bouton précédent.",
    "provideSheetName": "Veuillez fournir un nom de feuille",
    "sheetNameAlreadyExists": "Une feuille portant ce nom existe déjà",
    "provideSheetType": "Veuillez fournir un type de feuille",
    "didNotSpellDeleteProperly": "Vous n'avez pas orthographié DELETE correctement",
    "domainMustStartWithAt": "Le domaine doit commencer par '@'",
    "fillOutRequiredFields": "Veuillez remplir les champs obligatoires",
    "selectValidDates": "Veuillez sélectionner des dates valides",
    "noIapModeSelected": "Aucun mode IAP sélectionné. Veuillez sélectionner un mode.",
    "oneCollaboratorForWorkday": "Un seul collaborateur peut être sélectionné lors de la vérification de l'ensemble de la journée de travail",
    "fillRequiredDateTimeFields": "Veuillez remplir tous les champs de date et heure obligatoires",
    "endMustBeAfterStart": "La fin de la tâche doit être après le début",
    "recurrencesCannotExceed365": "Le nombre de récurrences ne peut pas dépasser 365",
    "pleaseFillNumberAndInterval": "Veuillez remplir le nombre et l'intervalle des récurrences",
    "pleaseFillNumberOfRecurrences": "Veuillez remplir le nombre de récurrences",
    "pleaseFillIntervalOfRecurrences": "Veuillez remplir l'intervalle des récurrences",
    "pleaseFillAllPeriodFields": "Veuillez remplir tous les champs de période",
    "pleaseSelectReportType": "Veuillez sélectionner au moins un type de rapport",
    "reportEmptyInInterval": "Le {{fileName}} est vide dans l'intervalle donné",
    "promptTooLong": "Requête trop longue (max 1200 caractères)",
    "nameTooLong": "Nom trop long (max 100 caractères)"
  }
}
